export const getUserName = (user) => {
    return user.cs_first_name || user.cs_last_name ? `${user.cs_first_name || ''} ${user.cs_last_name || ''}` : `Gast ${user.id}`;
}